module.exports = __webpack_public_path__ + "static/media/i_review_star_off.e6a754e9.png";